import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import useTranslation from "next-translate/useTranslation";
import React from "react";

import Props from "@sentrei/common/types/components/SpaceDashboard";
import SpaceCard from "@sentrei/ui/components/SpaceCard";
import SpaceFab from "@sentrei/ui/components/SpaceFab";
import SpaceNone from "@sentrei/ui/components/SpaceNone";

export default function SpaceDashboard({spaces}: Props): JSX.Element {
  const {t} = useTranslation();

  if (spaces?.length === 0) {
    return <SpaceNone />;
  }

  return (
    <div>
      <SpaceFab />
      <Box mt={3} mb={6}>
        <Typography
          variant="h3"
          align="center"
          color="textSecondary"
          component="h4"
        >
          {t("space:dashboard.title")}
        </Typography>
      </Box>
      <Container maxWidth="lg" component="main">
        <Grid container alignItems="center" justify="center" spacing={3}>
          {spaces?.map(space => (
            <Grid item key={space.id} xs={12} sm={6} md={4}>
              <SpaceCard space={space} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </div>
  );
}
